var map = {
	"./CustomForms/CustomRequestAccountForm": 61983,
	"./CustomForms/CustomRequestAccountForm.ts": 61983,
	"./CustomForms/SubmitGenericForm": 19973,
	"./CustomForms/SubmitGenericForm.ts": 19973,
	"./NishtechProcessFile": 26012,
	"./NishtechProcessFile.ts": 26012,
	"./SubmitAddressRequest": 51560,
	"./SubmitAddressRequest.ts": 51560,
	"./SubmitContactForm": 38563,
	"./SubmitContactForm.ts": 38563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83436;